import styled from 'styled-components';
import primitives from '@veneer/primitives';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${primitives.layout.size8}px ${primitives.layout.size5}px;
  text-align: center;
`;

export const Title = styled.h1`
  color: #5a5a5a; // color copied from HPC3 (it's not in primitives)
  font-weight: normal;
`;

export const Subtitle = styled.p`
  color: ${primitives.color.gray11}; // color copied from HPC3
  font-weight: 300;
`;
